import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/w/billing/')({
  staticData: { breadcrumb: 'Billing Engine' },
});
